"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const TEXT = {
  openMenu: "Открыть меню разделов",
  dialogTitle: "Разделы сайта"
} as const;

const LINKS = [
  { href: "/promotions", label: "Акции" },
  { href: "/rental", label: "Аренда" },
  { href: "/repair", label: "Ремонт" },
  { href: "/delivery", label: "Получение и оплата" },
  { href: "/contacts", label: "Контакты" }
] as const;

function MenuIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M4 7h16" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
      <path d="M4 12h16" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
      <path d="M4 17h16" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    </svg>
  );
}

export function MobileHeaderMenu() {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const shellRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handlePointerDown(event: MouseEvent) {
      if (!shellRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    function handleEscape(event: KeyboardEvent) {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    }

    window.addEventListener("mousedown", handlePointerDown);
    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("mousedown", handlePointerDown);
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <div className={`mobile-header-menu-shell ${isOpen ? "mobile-header-menu-shell--open" : ""}`} ref={shellRef}>
      <button
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        aria-label={TEXT.openMenu}
        className="mobile-header-menu-trigger"
        onClick={() => setIsOpen((current) => !current)}
        type="button"
      >
        <MenuIcon />
      </button>

      {isOpen ? (
        <div aria-label={TEXT.dialogTitle} className="mobile-header-menu-popover" role="dialog">
          <div className="mobile-header-menu-title">{TEXT.dialogTitle}</div>
          <nav className="mobile-header-menu-list">
            {LINKS.map((link) => {
              const isActive = pathname === link.href || pathname.startsWith(`${link.href}/`);

              return (
                <Link
                  aria-current={isActive ? "page" : undefined}
                  className={`mobile-header-menu-item ${isActive ? "mobile-header-menu-item--active" : ""}`}
                  href={link.href}
                  key={link.href}
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        </div>
      ) : null}
    </div>
  );
}
